import {getDefaultAutomationsFilter} from '@/views/automation/board/filter'

export const AUTOMATIONS_BOARD_SET_FILTER = 'AUTOMATIONS_BOARD_SET_FILTER'

const state = {
    boardAutomationsFilter: getDefaultAutomationsFilter()
}

const getters = {
    boardAutomationsFilter: state => state.boardAutomationsFilter
}

const mutations = {
    [AUTOMATIONS_BOARD_SET_FILTER]: (state, filter) => {
        state.boardAutomationsFilter = filter
    }
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
